import { CardContent, Grid, Box } from '@mui/material';
import {
  AIAvatar,
  CardCat,
  CategoryLabel,
  TextNameCard,
  TypoDescCard,
} from './StyleCardCategory';

import Link from 'next/link';
const CardCategory = ({ data }) => {
  return (
    <Grid container spacing={3}>
      {data?.map((index, key) => (
        <Grid item xs={12} sm={4} key={key} sx={{ cursor: 'pointer' }}>
          <CardCat>
            <Link href={`/ai/${index.slug}`} style={{ textDecoration: 'none' }}>
              <CardContent>
                <Box sx={{ display: 'flex', mb: 2 }}>
                  <AIAvatar>
                    {index.user.profilePicture ? (
                      <Box
                        component="img"
                        src={index.user.profilePicture}
                        alt={index.name}
                        sx={{ width: 36, height: 36 }}
                      />
                    ) : (
                      index.name
                    )}
                  </AIAvatar>
                  <Box sx={{ ml: 2 }}>
                    <TextNameCard>{index.name}</TextNameCard>

                    <CategoryLabel>{index.subTitle}</CategoryLabel>
                  </Box>
                </Box>
                <TypoDescCard color="text.secondary">
                  {index.description}
                </TypoDescCard>
              </CardContent>
            </Link>
          </CardCat>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardCategory;
